import type { SoldItemListRow } from '../services/soldItems.service';
import { formatCommercialSaleDate } from './sales/commercial-sale-date';
import { getSaleInvoiceLabel } from './sales/sale-invoice.utils';

import { BRANCH_RECEIPT_NUMBERING_ENABLED } from '../config/feature-flags';
import {
  BRANCH_RECEIPT_NUMBER_LABEL,
  SALES_ORDER_NUMBER_LABEL,
} from './sales/branch-receipt-numbering';

function escapeCsv(value: string | number): string {
  const s = String(value ?? '');
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function downloadSoldItemsCsv(rows: SoldItemListRow[], filename?: string): void {
  const header = [
    'Codigo',
    'Tipo',
    SALES_ORDER_NUMBER_LABEL,
    ...(BRANCH_RECEIPT_NUMBERING_ENABLED ? [BRANCH_RECEIPT_NUMBER_LABEL] : []),
    'Fecha de Venta',
    'Días hasta la venta',
    'Cliente',
    'Factura',
    'Precio de Venta',
    'Vendedor',
    'Ubicacion',
  ].join(',');

  const lines = rows.map((row) =>
    [
      row.productCodeUnique,
      row.categoryName,
      row.orderCode,
      ...(BRANCH_RECEIPT_NUMBERING_ENABLED ? [row.branchReceiptCode ?? ''] : []),
      formatCommercialSaleDate({ saleDate: row.saleDate, createdAt: row.saleDate }, 'es-ES', {
        includeTime: true,
      }),
      row.daysUntilSale,
      row.hasCustomer ? (row.customerName ?? 'Si') : 'No',
      getSaleInvoiceLabel(row.hasInvoice),
      row.finalPrice,
      row.sellerDisplayName,
      row.locationName,
    ]
      .map(escapeCsv)
      .join(','),
  );

  const csv = [header, ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename ?? `ventas_por_pieza_${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
